import React from 'react';
import styled, { css } from 'styled-components';

const shouldForwardProp = prop => !['selectedTab'].includes(prop);

const LoginTabStyled = styled.div`
  border-radius: 10px;
  background: var(--GrayScale-200, #ededed);
  padding: 3px;
  gap: 4px;
  display: flex;
  justify-content: space-between;
`;

const Tab = styled.div.withConfig({ shouldForwardProp })`
  flex: 1;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;

  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  color: var(--GrayScale-600);
  ${props =>
    props.selectedTab &&
    css`
      border-radius: 8px;
      background: var(--GrayScale-0);
      color: var(--GrayScale-900);
    `}
`;

const LoginTab = ({ tablist, selectedTab, setSelectedTab }) => {
  return (
    <LoginTabStyled>
      {tablist.map((tab, index) => (
        <Tab key={index} selectedTab={selectedTab === index} onClick={() => setSelectedTab(index)}>
          {tab}
        </Tab>
      ))}
    </LoginTabStyled>
  );
};

export default LoginTab;
